import react from "react";

const ArchetypeList = (props) => {

    return (
        <div>
            {props.archetypes.length === 0 ? (
                <p>No archetypes found.</p>
            ) : (
                <ul className="admin-ul">
                    <h3>Archetypes</h3>
                    <li className="list-item header">
                            <div>
                                <p>Archetype</p>
                                <p>Active</p>
                            </div>
                    </li>
                    {props.archetypes.map((archetype) => (
                        <li className="list-item form-group inline" key={archetype._id} onClick={() => props.onShowArchetypeDetails(archetype)}>
                            <div>
                                <div>{archetype.title}</div>
                            </div>
                            <div>
                                <div>{archetype.active ? "✓" : ""}</div>
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default ArchetypeList;